import {CREATE_TASK} from '../actiontypes';
import {API_RESOURCES, createApiCreateAction} from '../../util/api';

export function createTask(engagementId, task) {
	return createApiCreateAction(
		CREATE_TASK,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TASKS]: undefined
		},
		task,
		{resolve: true}
	);
}
